import { useTranslation } from "react-i18next";
import {
  enumloginstatusToI18nKey,
  type EnumLoginStatus,
} from "../../../generated/enums";

/**
 * Couleur par issue d'une tentative de connexion.
 *
 * `login_bad_credentials` en rouge : c'est LE signal à repérer dans une liste — une
 * série de refus sur un même compte ou une même IP est le motif d'une attaque par force
 * brute. `login_error` reste gris : c'est une panne technique, pas un fait d'usage, et
 * la colorer en rouge noierait les vrais refus.
 *
 * `login_unknown_account` en orange : AUTH a validé le mot de passe mais USERS n'a pas
 * de profil — une incohérence entre les deux bases, à surveiller sans être une alerte
 * de sécurité.
 *
 * ⚠️ Palette réelle du projet (tailwind.config.js) : `secondary` #A9B54B,
 * `tertiary` #293610, `warning` #FF9800, `red-*`, `grey-*`. La palette Tailwind par
 * défaut n'est PAS chargée : `bg-primary` et `amber-*` n'existent pas, et une classe
 * inconnue ne lève aucune erreur — elle rend juste la pastille sans fond.
 */
const STATUS_CLASSES: Record<EnumLoginStatus, string> = {
  login_success: "bg-secondary text-white",
  login_bad_credentials: "bg-red-700 text-white",
  login_unknown_account: "bg-warning text-default-text",
  login_error: "bg-grey-medium text-white",
};

/**
 * Pastille de statut. Le libellé traduit est TOUJOURS présent : la couleur seule n'est
 * pas une information accessible (daltonisme, impression noir et blanc).
 */
export const LoginStatusBadge = ({ status }: { status: EnumLoginStatus }) => {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${STATUS_CLASSES[status]}`}
    >
      {t(enumloginstatusToI18nKey[status])}
    </span>
  );
};
